import React from 'react';
import '../Top.css';
import '../Layout.css'
import '../index.css'
import { NavLink } from 'react-router-dom';

export default class Post extends React.Component {
    render() {
        console.log(this.props.PostDate.Thumbnail.Image)
        return (
            <>
                <div className="post">
                    <div className="postImg">
                        <img src={`${process.env.PUBLIC_URL}/${this.props.PostDate.Thumbnail.Image}`} alt={this.props.PostDate.Thumbnail.alt} title={this.props.PostDate.Thumbnail.title} />
                    </div>
                    <div className="postInformation">
                        <div className="articleDate">
                            <p>Day: {this.props.PostDate.Date.Day}</p>
                            <p>Month: {this.props.PostDate.Date.Month}</p>
                            <p>Year: {this.props.PostDate.Date.Year}</p>
                        </div>
                        <p className="postTitle">{this.props.PostDate.Title}</p>
                        <div className="browsingArticle">
                            <NavLink activeClassName="active" to={this.props.PostDate.URL}>
                                <button className="browsingArticleButton">
                                    Visit
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
